import { Reveal } from "@/components/Reveal";

export const LegalSection = ({ id, title, children }) => (
  <section id={id} data-testid={id ? `legal-section-${id}` : undefined} className="scroll-mt-32">
    <h2 className="font-display font-extrabold tracking-tight text-xl sm:text-2xl text-leaf">{title}</h2>
    <div className="mt-3 space-y-4 text-base text-ink/80 leading-relaxed">{children}</div>
  </section>
);

export const LegalList = ({ items }) => (
  <ul className="space-y-2.5">
    {items.map((item) => (
      <li key={item} className="flex gap-3">
        <span className="mt-2.5 h-1.5 w-1.5 rounded-full bg-flame shrink-0" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const LegalDoc = ({ title, updated, children }) => (
  <main data-testid={`legal-page-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
    <section className="pt-44 sm:pt-60 pb-24 lg:pb-32 relative overflow-hidden grain">
      <div className="absolute inset-0 dot-grid opacity-50 pointer-events-none" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-8">
        <Reveal>
          <h1
            data-testid="legal-title"
            className="font-display font-extrabold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl text-leaf uppercase"
          >
            {title}
          </h1>
        </Reveal>
        <Reveal delay={0.12}>
          <p data-testid="legal-updated" className="mt-4 font-mono text-xs tracking-[0.2em] text-ink-muted font-bold uppercase">
            Last updated: {updated}
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-12 space-y-12">{children}</div>
        </Reveal>
      </div>
    </section>
  </main>
);

export default LegalDoc;
